export const SITE_NAME = 'GPS Map Updates';
export const SITE_DOMAIN = 'gpsmapupdates.online';
export const SITE_URL = 'https://www.gpsmapupdates.online';

export const COMPANY_NAME = 'Opulence Technologies';
export const COMPANY_ADDRESS = '212 N. 2nd Street, STE 100, Richmond, KY 40475';

export const SUPPORT_EMAIL = `support@${SITE_DOMAIN}`;
